export const chartOptions = {
  maintainAspectRatio: false,
  aspectRatio: 0.8,
  plugins: {
    tooltips: {
      mode: "index",
      intersect: false,
    },
    legend: {
      display: false,
      labels: {
        color: "#495057",
        position: "bottom",
      },
    },
  },
  scales: {
    x: {
      stacked: true,
      ticks: {
        color: "#495057",
      },
      grid: {
        color: "#ebedef",
      },
    },
    y: {
      ticks: {
        beginAtZero: true,
        callback: function (value) {
          if (value % 1 === 0) {
            return value
          }
        },
        color: "#495057",
      },
      grid: {
        color: "#ebedef",
        drawBorder: false,
      },
    },
  },
}
